import { NavItemAccessor } from '../types/navItemAccessor'

export const SELECTABLE_ACCESSORS: NavItemAccessor[] = [
  NavItemAccessor.HeaderBreadcrumb,
  NavItemAccessor.WithoutActiveState,
]
